<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
    dashboard
  >
    <v-layout wrap>
      <v-flex
        v-if="getTraderMode && getUser && getUser.count_projects == 0"
        xs12
      >
        <v-card
          style="padding:7px;"
        >
          <v-layout wrap>
            <v-flex
              xs9
              md9
              pl-5
              align-self-center
            >
              <small>{{ $t('dashboard.startProjectMessage') }}</small>
            </v-flex>
            <v-flex
              xs3
              md3
              text-right
              align-self-center
              justify-end
            >
              <router-link to="/projects">
                <v-btn
                  outlined
                  small
                  text
                >
                  {{ $t('dashboard.startButton') }}
                </v-btn>
              </router-link>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex
        md5
        xs12
      >
        <v-card
          height="100%"
          class="d-flex align-center justify-center"
        >
          <aum-per-project-pie />
        </v-card>
      </v-flex>
      <v-flex
        md7
        xs12
      >
        <overview />
      </v-flex>

      <v-flex
        xs12
      >
        <v-card height="100%">
          <v-card-title>
            <v-row>
              <v-col class="pt-0 pb-0">
                {{ $t('traderdashboard.accountsAuM') }}
              </v-col>
              <v-col class="pt-0 pb-0 text-right">
                <v-btn
                  v-if="accAuMFound"
                  small
                  text
                  @click="$router.push('/investors')"
                >
                  {{ $t('traderdashboard.more') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <investors />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import Overview from "@/views/TraderDashboard/partial/Overview.vue";
import Investors from "@/views/TraderDashboard/partial/Investors.vue";
import AumPerProjectPie from "@/views/TraderDashboard/partial/AumPerProjectPie.vue";

export default {
  name: "TraderDashboard",
  components: {
    Overview,
    Investors,
    AumPerProjectPie
  },
  data: () => ({
    tab: 0,
    tooltip: null,
    loading: false,
    traderMode: false,
    countAccs: 0,
    countProjects: 0,
    accAuMFound: false,
    countedAccs: 0
  }),
  computed: {
    ...mapGetters("app", ["getTraderMode"]),
    ...mapGetters("user", ["getUser"])
  },
}
</script>



<style lang="scss" >
@import "@/styles/material-dashboard/_colors.scss";

.dashboard {
  .v-card__text {
    padding: 3px;
    .v-avatar {
      border-radius: 50% !important;
      background: #173eb7;
      margin-top: -2px;
      .v-icon {
        color: $grey-100;
      }
    }
    span {
      font-weight: 400;
      font-size: 20px;
      margin: 10px;
      color: $black;
    }
  }
}
</style>
